<template>
  <div
    v-if="assistant"
    class="fixed inset-y-0"
    :class="[
      assistant ? 'z-[500]' : '',
      'fixed md:translate-x-0',
      assistant && uiStore.mobile
        ? 'flex h-full w-full translate-x-0 flex-col overflow-y-auto bg-white transition'
        : '-translate-x-full',
    ]"
  >
    <v-btn
      class="absolute right-1 top-1"
      icon
      :color="vgOcean"
      @click="removeVA"
    >
      <fa-icon icon="fa-regular fa-xmark-large" />
    </v-btn>
    <div
      class="card bg-white text-center"
      :class="[
        'min-w-[200px] rounded-2xl bg-white p-4',
        assistant.isSpecial ? 'bg-vgocean-200' : '',
        uiStore.mobile ? 'mx-4' : 'card mx-0 flex flex-col',
      ]"
    >
      <div class="pb-5">
        <div class="flex flex-col">
          <div class="relative">
            <v-avatar size="112" class="mb-2 bg-white">
              <v-img :src="getAvatar(assistant)"> </v-img>
            </v-avatar>
          </div>
        </div>
      </div>
      <div class="flex flex-col">
        <p class="name-cut mb-2 self-center text-base font-bold">
          {{ assistant.display_name }}
        </p>
        <div class="grid grid-flow-row justify-items-center"></div>
        <p class="cut my-2 h-[9] text-sm">
          {{ assistant.blurb }}
        </p>
        <a href="#" @click.prevent="removeVA"> Sign up to get full access! </a>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/config';
import { mapStores } from 'pinia';
import { useUiStore } from '@/stores/ui';
import tailwind from 'tailwind.config';

export default {
  name: 'VaCard',
  props: {
    assistant: {
      type: Object,
      default: null,
    },
  },
  emits: ['removeVA'],
  data() {
    return {
      vgOcean: tailwind.theme.extend.colors.vgocean[500],
    };
  },
  computed: {
    ...mapStores(useUiStore),
  },
  methods: {
    getAvatar(assistant) {
      if (assistant.avatar_id === -1) {
        return '/img/profile.png';
      }
      return `${API_URL}/file/avatar/${assistant.avatar_id}`;
    },
    removeVA() {
      this.$emit('removeVA');
    },
  },
};
</script>

<style></style>
